import React from "react";
import { getCurrency } from "@/lib/currencies";

const DEFAULT_PRESETS = [10, 50, 100, 500, 1000];

export const QuickAmounts = ({ currency = "INR", presets = DEFAULT_PRESETS, onPick, selected }) => {
  const sym = getCurrency(currency).symbol;
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar mb-4 -mx-1 px-1" data-testid="quick-amounts">
      {presets.map((v) => (
        <button
          key={v}
          type="button"
          onClick={() => onPick(String(v))}
          className={`shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold transition ${
            String(selected) === String(v) ? "btn-gold" : "btn-outline-gold"
          }`}
          data-testid={`quick-amt-${v}`}
        >
          {sym}
          {v}
        </button>
      ))}
    </div>
  );
};
